import { authGet, authPost, authPut } from '../../../../shared/sso-workspace/auth-api'

// Auth's staff sign-in methods (SYS_PROVIDER: read to see, update to change;
// edxr-workspace/.superpowers/signin-methods/design.md §5). Each resolves to
// the answer's body and throws the response ({ status, data: { code,
// message } }) on a refusal, as every auth-api call does: serverMessage(err)
// reads the sentence and ErrorReference the request behind it.
//
//   GET  signin-method              { available, migration?, methods: [MethodView] }
//   GET  signin-method/:kind        MethodView with notice, staffNote, options, configuration
//   POST signin-method/:kind        set up (state off): the detail view
//   PUT  signin-method/:kind        any of { label, state, notice, staffNote, settings, confirmEntryPoint }
//   PUT  signin-method/order        { kinds }: the list answer
//   POST signin-method/:kind/check  { status, summary, fix?, code?, thumbprint?, checkedAt }
const path = kind => `signin-method/${encodeURIComponent(kind)}`

export const listSigninMethods = () => authGet('signin-method')
export const getSigninMethod = kind => authGet(path(kind))
export const setUpSigninMethod = kind => authPost(path(kind), {})
export const updateSigninMethod = (kind, body) => authPut(path(kind), body)
export const orderSigninMethods = kinds => authPut('signin-method/order', { kinds })
export const checkSigninMethod = kind => authPost(`${path(kind)}/check`, {})
